import React from 'react';





const BusinessTab = (props) => {

    
 
  

  

    return (
        <div className={`tab-pane ${props.isActive ? 'active' : ''}`}>          
       
       BusinessTab

        </div>
    );
};

export default BusinessTab;